import { mergeClassName as e } from "../../utils/data.js";
import { ButtonIcon as t } from "../Button/ButtonIcon.js";
import { Card as n } from "../Card/Card.js";
import { Close as r, Content as i, Dialog as a, DialogOverlay as o, DialogPortal as s, DialogTitle as c } from "../../node_modules/@radix-ui/react-dialog/dist/index.js";
import l from "./Modal.module.js";
import { Typography as u } from "../Typography/Typography.js";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { XIcon as m } from "@phosphor-icons/react";
//#region lib/components/Modal/Modal.tsx
function h({ icon: h, title: g, children: _, footer: v, unwrappedContent: y, scrollable: b = !0, overlayProps: x, contentProps: S, cardProps: C, ...w }) {
	return /* @__PURE__ */ f(a, {
		...w,
		children: /* @__PURE__ */ f(s, { children: /* @__PURE__ */ p("div", {
			className: l.layer,
			children: [/* @__PURE__ */ f(o, {
				...x,
				className: e(l.overlay, x?.className)
			}), /* @__PURE__ */ f(i, {
				...S,
				className: e(l.content, S?.className),
				children: y === void 0 ? /* @__PURE__ */ p(n, {
					color: "white",
					...C,
					className: e(l.card, C?.className),
					children: [
						/* @__PURE__ */ p("header", {
							className: l.header,
							children: [/* @__PURE__ */ p("div", {
								className: l.headerLeft,
								children: [h != null && /* @__PURE__ */ f("div", {
									className: l.headerIcon,
									children: h
								}), g != null && /* @__PURE__ */ f(c, {
									asChild: !0,
									className: l.headerTitle,
									children: typeof g == "string" ? /* @__PURE__ */ f(u, {
										variant: "heading-medium",
										children: g
									}) : g
								})]
							}), /* @__PURE__ */ f("div", {
								className: l.closeButtonWrapper,
								children: /* @__PURE__ */ f(r, {
									asChild: !0,
									"aria-label": "Close",
									children: /* @__PURE__ */ f(t, {
										icon: /* @__PURE__ */ f(m, { size: 24 }),
										color: "neutral",
										noBorder: !0
									})
								})
							})]
						}),
						/* @__PURE__ */ f("div", {
							className: b ? l.scrollableBody : void 0,
							children: _
						}),
						v && /* @__PURE__ */ f("footer", {
							className: l.footer,
							children: v
						})
					]
				}) : /* @__PURE__ */ p(d, { children: [g != null && /* @__PURE__ */ f(c, {
					className: l.visuallyHidden,
					children: g
				}), y] })
			})]
		}) })
	});
}
//#endregion
export { h as Modal };
